import React from 'react';
import { Reveal } from './Reveal';
import { images, strategistTraits } from '../data/content';
export function Transformation() {
  return <section className="bg-gradient-to-b from-wine/70 to-ink px-6 py-20" data-id="element-144" data-mp="ikt041g01mu5">
      <Reveal data-id="element-145" data-mp="ml379hfj2jal">
        <img src={images.portrait} alt="MSc Beatriz Espina vestida de blanco, sentada en su consultorio" className="h-auto w-full rounded-xl border border-gold shadow-[0_20px_50px_-20px_rgba(0,0,0,0.8)]" data-id="element-146" data-mp="mkl0vrz5iooy" />
        <h2 className="mt-10 font-serif text-[32px] font-bold leading-tight text-white" data-id="element-147" data-mp="11j59noatoyq9">
          Así es una mujer Estratega.
        </h2>
        <p className="mt-4 text-base text-muted" data-id="element-148" data-mp="16bevot8then9">Es la mujer que:</p>
        <ul className="mt-6 space-y-4" data-id="element-149" data-mp="1ac8jlmm9etg5">
          {strategistTraits.map(trait => <li key={trait} className="flex gap-3 text-base leading-relaxed text-white" data-id="element-150" data-mp="1fb1xhg5gkmgu">
              <span aria-hidden="true" className="mt-[3px] text-xs text-gold" data-id="element-151" data-mp="1k9wf4erow4zd">
                ◆
              </span>
              <span data-id="element-152" data-mp="1c6jlv2k67c1c">{trait}</span>
            </li>)}
        </ul>
      </Reveal>
    </section>;
}